var _path, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66701 1.66687H18.3V18.2917H1.66701V1.66687Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2223)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37534 2.91675C4.27451 2.91675 2.91701 4.35592 2.91701 6.58258V13.3759C2.91701 15.6034 4.27451 17.0417 6.37534 17.0417H13.5837C15.6895 17.0417 17.0503 15.6034 17.0503 13.3759V6.58258C17.0503 4.35592 15.6895 2.91675 13.5837 2.91675H6.37534ZM13.5837 18.2917H6.37534C3.55867 18.2917 1.66701 16.3159 1.66701 13.3759V6.58258C1.66701 3.64258 3.55867 1.66675 6.37534 1.66675H13.5837C16.4045 1.66675 18.3003 3.64258 18.3003 6.58258V13.3759C18.3003 16.3159 16.4045 18.2917 13.5837 18.2917Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40117 14.317C4.24617 14.317 4.09201 14.2603 3.97117 14.1453C3.72034 13.9086 3.71034 13.512 3.94784 13.2628L5.22117 11.9186C5.89534 11.2028 7.03284 11.1678 7.75201 11.8428L8.55034 12.6528C8.77284 12.8778 9.13451 12.882 9.35784 12.662C9.44201 12.5628 11.257 10.3586 11.257 10.3586C11.602 9.94031 12.0887 9.68198 12.6295 9.62864C13.1712 9.58114 13.697 9.73864 14.1162 10.0828C14.152 10.112 14.1845 10.1403 16.0145 12.0195C16.2553 12.2661 16.2512 12.662 16.0037 12.9028C15.757 13.1453 15.3603 13.1378 15.1195 12.8911C15.1195 12.8911 13.412 11.1386 13.2903 11.0203C13.1612 10.9145 12.9537 10.8528 12.7495 10.8728C12.542 10.8936 12.3553 10.9928 12.2228 11.1536C10.2862 13.5028 10.2628 13.5253 10.2312 13.5561C9.51617 14.2578 8.36201 14.2461 7.65951 13.5295C7.65951 13.5295 6.88451 12.7428 6.87117 12.727C6.67867 12.5486 6.33534 12.5603 6.12951 12.7778L4.85451 14.122C4.73117 14.252 4.56617 14.317 4.40117 14.317Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13134 6.77417C6.6705 6.77417 6.2955 7.14917 6.2955 7.61084C6.2955 8.0725 6.6705 8.44834 7.13217 8.44834C7.59383 8.44834 7.96967 8.0725 7.96967 7.61084C7.96967 7.15 7.59384 6.775 7.13134 6.77417ZM7.13217 9.69834C5.98133 9.69834 5.0455 8.76167 5.0455 7.61084C5.0455 6.46 5.98133 5.52417 7.13217 5.52417C8.28384 5.525 9.21967 6.46167 9.21967 7.61084C9.21967 8.76167 8.283 9.69834 7.13217 9.69834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.38c7e73699af83299af3b9a1c43143e8.svg";
export { ForwardRef as ReactComponent };